import type { ReactNode } from 'react';

export interface ChartProps {
  /** inline <svg> generated by the blog skills (or any chart node) */
  children: ReactNode;
  caption?: ReactNode;
}

/** Figure wrapper for an inline-SVG data chart, with an optional caption. */
export const Chart = ({ children, caption }: ChartProps) => (
  <figure className="my-6">
    <div className="overflow-x-auto rounded-10 border border-line bg-surface-2 p-4 [&_svg]:h-auto [&_svg]:max-w-full">
      {children}
    </div>
    {caption ? (
      <figcaption className="mt-2 text-center text-13 text-text-3">{caption}</figcaption>
    ) : null}
  </figure>
);
